import { Result } from 'antd';
import { useInjection } from 'inversify-react';
import { useMediaQuery } from 'react-responsive';

import { Button, Image, Text, useTheme } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

import { IProjectManager } from '../../../core/viewer/project-manager';
import { TYPES } from '../../../inversify.types';
import { Logo } from '../../components/Logo';
import {
  StyledErrorButtonContainer,
  StyledErrorImageContainer,
  StyledErrorMessageWrapper,
  StyledErrorWrapper,
  StyledFixWrapper,
} from './ErrorPage.style';

export interface ErrorPageProps {
  pageTitle: string;
  message: string;
  code: number;
  imageUrl: string;
  button?: {
    label: string;
    onClick?: (event: React.MouseEvent | React.TouchEvent) => void;
  };
}

export function ErrorPage(props: ErrorPageProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery({ maxWidth: theme.Screen.Size.Medium });
  const projectManger = useInjection<IProjectManager>(TYPES.Viewer.ProjectManager);
  const { t } = useTranslation();
  const handleClick = (event: React.MouseEvent | React.TouchEvent) => {
    event.stopPropagation();
    props.button?.onClick?.(event);
  };

  function handleLogoClick() {
    projectManger.quitViewer();
  }

  return (
    <StyledErrorWrapper data-testid="error-page" isMobile={isMobile}>
      <StyledFixWrapper>
        <Logo title={t('tool.project.exit_message')} onClick={handleLogoClick} />
      </StyledFixWrapper>
      <Result
        icon={
          <StyledErrorImageContainer isMobile={isMobile}>
            <Image source={props.imageUrl} alt={`Image of ${props.code} Custom Error Page`} />
          </StyledErrorImageContainer>
        }
        title={<Text children={props.pageTitle} size="DisplaySmall" />}
        subTitle={
          <StyledErrorMessageWrapper>
            <Text children={props.message} size="Body" color={theme.Color.Neutrals.Gray} />
          </StyledErrorMessageWrapper>
        }
        extra={
          props.button && (
            <StyledErrorButtonContainer isMobile={isMobile}>
              <Button
                action="error-page-action"
                onClick={(event) => {
                  handleClick(event);
                }}
              >
                {props.button.label}
              </Button>
            </StyledErrorButtonContainer>
          )
        }
      />
    </StyledErrorWrapper>
  );
}
